<template>
  <div class="box-delivery-info">
    <a v-if="delivery.shippingInfo " href="javascript:void(0)" class="text--underline shipping-info" style="word-wrap: anywhere;" @click.prevent="showFormRegister">{{ sliceShippingInfo(delivery.shippingInfo) }}</a>
    <button v-else-if="delivery.deliveryKbn === '01' && !delivery.isDeleted" type="button" class="btn btn-primary check-maintenance" @click.prevent="showFormRegister">発送情報登録</button>
    <button v-else type="button" class="btn disabled" disabled="true">発送情報登録</button>

    <div v-if="isPopupVisible" :class="`box-form-delivery-info delivery-info-${delivery.deliveryNo}`" @click.stop>
      <strong>「追跡番号が記載されたURL」もしくは「配送事業者名と追跡番号」を入力してください。</strong>
      <div class="box-info-input">
        <div>{{ exampleRegisterText }}</div>
        <textarea v-model.trim="shippingInfoInput" class="form-control delivery-info" name="delivery-info" rows="3"></textarea>
        <button type="button" class="btn btn-primary m-t-sm check-maintenance" :disabled="!shippingInfoInput" @click="deliveryInfoRegister()">登録する</button>
      </div>
    </div>
  </div>
</template>

<script>
import WarehouseAcrossService from '@/services/warehouseacrossservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    delivery: {
      type: Object,
      default () {
        return {}
      }
    },
    activeDeliveryNo: {
      type: String
    }
  },
  data () {
    return {
      shippingInfoInput: null,
      loader: null
    }
  },
  computed: {
    isPopupVisible () {
      return this.activeDeliveryNo === this.delivery.deliveryNo
    },
    exampleRegisterText () {
      return '(例) ヤマト運輸：123412341234、日本郵便：123412341234'
    }
  },
  methods: {
    showFormRegister (event) {
      event.stopPropagation()
      this.$emit('updateActiveDeliveryNo', this.delivery.deliveryNo)
    },
    deliveryInfoRegister () {
      if (!this.shippingInfoInput) {
        return
      }
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.list.click_regis_shipping_info_btn,
        properties: {
          deliveryNo: this.delivery.deliveryNo,
          input: this.shippingInfoInput
        }
      }
      EventService.postTrackLog(logParams)
      this.loader = this.$loading.show()
      let params = {
        deliveryNo: this.delivery.deliveryNo,
        shippingInfo: this.shippingInfoInput
      }
      WarehouseAcrossService.updateShippingInfo(params)
        .then((response) => {
          this.delivery.shippingInfo = this.shippingInfoInput
          this.$emit('updateActiveDeliveryNo', null)
          this.loader && this.loader.hide()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    sliceShippingInfo (value) {
      if (value.length < 20) {
        return value
      }

      return value.slice(0, 20) + '...'
    }
  },
  mounted () {
    this.shippingInfoInput = this.delivery.shippingInfo
  },

  beforeDestroy () {
    this.shippingInfoInput = null
    this.loader && this.loader.hide()
  }
}
</script>
<style scoped>
.btn.disabled {
  background-color: #efefef;
  color: #000;
  border: 1px solid #ccc;
}
.box-delivery-info {
  position: relative;
}
.box-form-delivery-info {
  position: absolute;
  background-color: #ffffff;
  z-index: 999;
  width: 650px;
  padding: 5px 20px 10px;
  border: 1px solid #ddd;
  webkit-box-shadow: 1px 2px 10px rgb(0 0 0 / 70%);
  box-shadow: 1px 2px 10px rgb(0 0 0 / 70%);
  right: 140px;
  top: -20px;
  cursor: auto;
}
.box-form-delivery-info::before {
  border-right: 30px solid transparent;
  border-top: 40px solid #ddd;
  content: "";
  display: inline-block;
  position: absolute;
  top: 38.5px;
  right: -35px;
}
.box-form-delivery-info::after {
  border-right: 30px solid transparent;
  border-top: 40px solid #ffffff;
  content: "";
  display: inline-block;
  position: absolute;
  top: 41px;
  right: -28px;
}
.box-info-input {
  padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/components/ShippingInfo.vue